<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-customer-sidebar>
  <app-crud-table body [crudService]="crudService"
                  [transPartKey]="transPartKey" [fieldId]="fieldId" [fieldName]="'traderCode'"
                  [tableConfig]="tableConfig" [newRecord]="newRecord"
                  [(formRecord)]="formRecord" [formConfig]="formConfig"
                  [settingsFormLoadingProgressValue]="settingsFormLoadingProgressValue"
                  (dialogFormVisibleChange)="$event?onFormShow():{}"
                  [formLoading]="formLoading"
                  [writeRoles]="CCRoles.ROLES_CUSTOMER_WRITE_TRADER" [totalRecords]="totalRecords"
                  [tableLoading]="tableLoading"
                  [(dialogFormVisible)]="dialogFormVisible"
                  [(selectedRecords)]="selectedRecords" [dialogFormTitle]="dialogFormTitle"
                  [contextMenuConfig]="contextMenuConfig" [headerButtonConfig]="headerButtonConfig"
                  [(tableCurrentRequest)]="tableCurrentRequest" [(records)]="records" (onSave)="onSaved()"
                  (onContextMenuShow)="refreshContextMenu()"
                  [globalErrorMessage]="globalErrorMessage"
                  [globalInfoMessage]="globalInfoMessage"
  ></app-crud-table>
</app-customer-sidebar>

<app-batch-action-account-trader-form [(dialogFormVisible)]="batchUpdateDialogVisible"
                                [formRecord]="formRecord"
                                [selectedRecords]="selectedRecords"
                                [dataLoadingService]="dataLoadingService"
                                [transPartKey]="transPartKey"
                                (onSavedForm)="onSaved()"
                                [tracker]="tracker"
                                [settingsFormLoadingProgressValue]="settingsFormLoadingProgressValue"
                                [action]="batchAction"></app-batch-action-account-trader-form>
